import { IStyleProps } from './Interface'
import { makeStyles } from '@material-ui/core/styles'

export default makeStyles<{}, IStyleProps>({
    root: {
        display: ({ visible }) => (visible ? 'inline-flex' : 'none')
    },
    button: {
        padding: 0,
        color: '#e3e0e0',
        margin: 6,
        '&:hover': {
            background: 'none',
            boxShadow: '0 0 3px 5px rgba(0,0,0,.1)'
        }
    },
    accept: {
        '&:hover': {
            color: '#aaff80'
        }
    },
    reject: {
        '&:hover': {
            color: '#ff9980'
        }
    }
})
